module.exports = __webpack_public_path__ + "img/pola_musium.4a0aa455.jpg";